import React from 'react';

import scss from './SideBar.module.scss';
import { getAsset } from '@helper/getConfigValues';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

const BannerDw = () => {
  return (
    <div className={scss.banner} style={{ backgroundImage: `url(${getAsset("images/dw-card.jpg")})` }}>
      <div className={scss.overlay}>
        <div className={scss.topText}>Your best day ever but in <span className={scss.paradise}>paradise</span></div>
        <div className={scss.bottomText}>
          <div className={'mb-2'}>
            All-inclusive Destination Wedding packages now available.
          </div>
          <div>
            <a href="/destination-weddings/" className={scss.dwLink}>
              View Packages <span className={scss.arrowIcon}>&rarr;</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerDw;
